import type { Translations } from './de'

const hr: Translations = {
  'language.flag': '🇭🇷',
  'language.name': 'Hrvatski',
  'navigation.home': 'Početna',
  'navigation.language': 'Jezik',
  'navigation.openMenu': 'Otvori izbornik',
  'navigation.closeMenu': 'Zatvori izbornik',
  'navigation.skipToContent': 'Preskoči na sadržaj',
  'categories.sightseeing.name': 'Znamenitosti',
  'categories.sightseeing.heading': 'Najpopularnije znamenitosti Augsburga',
  'categories.sightseeing.lead': 'Od UNESCO-ove svjetske baštine do Fuggereija: Augsburg nudi više nego što misliš.',
  'categories.events.name': 'Događanja',
  'categories.events.heading': 'Sva događanja na jednom mjestu',
  'categories.events.lead': 'Koncerti, tržnice, razgledavanja grada: saznaj što se ovaj tjedan događa u Augsburgu.',
  'categories.blog.name': 'Novosti',
  'categories.blog.heading': 'Novosti iz Augsburga',
  'categories.blog.lead': 'Pozadinske priče, povijest grada i aktualne teme za čitanje i prepričavanje.',
  'categories.emptyTitle': 'Ovdje još nema ničega',
  'categories.emptyDescription': 'U ovom odjeljku još nema stranica. Svrati uskoro ponovno.',
  'home.title': 'Dobro došli u Augsburg',
  'home.intro': 'Bilo da je riječ o gradskom izletu, poslovnom putovanju ili obiteljskom posjetu, ovdje ćeš pronaći sve važne informacije za svoj boravak u Augsburgu.',
  'home.sightseeing.eyebrow': 'Grad UNESCO-ove svjetske baštine',
  'home.sightseeing.title': 'Otkrij znamenitosti',
  'home.sightseeing.lead': 'Od UNESCO-ove svjetske baštine do Fuggereija: Augsburg nudi više nego što misliš.',
  'home.sightseeing.action': 'Otkrij sada',
  'home.events.eyebrow': 'Što se događa u Augsburgu?',
  'home.events.title': 'Pronađi događanja',
  'home.events.lead': 'Ne propusti više nijedan koncert, buvljak ili festival. Na našoj stranici događanja uvijek si u tijeku.',
  'home.events.action': 'Sva događanja',
  'home.blog.eyebrow': 'Priče iz grada',
  'home.blog.title': 'Novosti i zanimljivosti',
  'home.blog.lead': 'Ovdje ćeš pronaći sve važno o Augsburgu za svoj posjet.',
  'home.blog.action': 'Na blog',
  'home.language.eyebrow': 'Augsburg je međunarodan',
  'home.language.title': 'Prebaci na svoj jezik',
  'home.language.lead': 'Ova je stranica dostupna na više jezika. Želiš li promijeniti jezik?',
  'home.highlights.eyebrow': 'Odabrano za tebe',
  'home.highlights.title': 'Naše preporuke',
  'home.highlights.lead': 'Za dobar početak odabrali smo za tebe nekoliko vrhunaca Augsburga. Ugodno čitanje!',
  'search.placeholder': 'Pretraži...',
  'search.clear': 'Obriši pretragu',
  'search.label': 'Pretraži stranice',
  'search.results': '{{count}} rezultata za „{{query}}”',
  'search.emptyTitle': 'Nema rezultata',
  'search.emptyDescription': 'Za ovu pretragu nismo ništa pronašli. Pokušaj s drugim pojmom.',
  'pagination.label': 'Stranice',
  'pagination.previous': 'Prethodna stranica',
  'pagination.next': 'Sljedeća stranica',
  'pagination.page': 'Stranica {{page}}',
  'pagination.summary': '{{start}}–{{end}} od {{total}}',
  'page.back': 'Natrag',
  'page.readMore': 'Saznaj više',
  'page.tableOfContents': 'Na ovoj stranici',
  'page.openInGoogleMaps': 'Otvori u Google Kartama',
  'map.copyAddress': 'Kopiraj adresu',
  'map.copied': 'Kopirano',
  'map.copyFailed': 'Kopiranje nije moguće',
  'map.routeInGoogleMaps': 'Ruta u Google Kartama',
  'map.zoomIn': 'Povećaj',
  'map.zoomOut': 'Smanji',
  'map.showAll': 'Prikaži sve',
  'attribution.toggle': 'Prikaži ili sakrij izvore',
  'map.gestures.windows': 'Koristi Ctrl + pomicanje za zumiranje karte',
  'map.gestures.mac': 'Koristi ⌘ + pomicanje za zumiranje karte',
  'map.gestures.mobile': 'Pomiči kartu s dva prsta',
  'map.loading': 'Karta se učitava …',
  'map.failed': 'Kartu nije bilo moguće učitati.',
  'map.showPlace': 'Prikaži {{name}} na karti',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'oko {{duration}} pješice',
  'map.route.stops': '{{count}} postaja',
  'map.route.leg': '{{distance}} · oko {{duration}}',
  'mapIcons.landmark': 'Znamenitost',
  'mapIcons.church': 'Crkva',
  'mapIcons.museum': 'Muzej',
  'mapIcons.park': 'Park i priroda',
  'mapIcons.viewpoint': 'Vidikovac',
  'mapIcons.cafe': 'Kafić',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restoran',
  'mapIcons.shop': 'Kupovina',
  'mapIcons.event': 'Mjesto događanja',
  'mapIcons.transport': 'Prijevoz',
  'mapIcons.place': 'Mjesto',
  'footer.imprint': 'Impresum',
  'footer.privacy': 'Pravila privatnosti',
  'footer.mediaLicense': 'Prava na slike',
  'legal.bindingNote': 'Ovaj prijevod služi samo u informativne svrhe. Pravno je obvezujuća isključivo njemačka verzija.',
  'imprint.provider.heading': 'Podaci prema § 5 DDG',
  'imprint.contact.heading': 'Kontakt',
  'imprint.contact.email': 'E-pošta',
  'imprint.responsible.heading': 'Odgovoran za sadržaj prema § 18 st. 2 MStV',
  'privacy.intro': 'Ova pravila privatnosti objašnjavaju koji se osobni podaci obrađuju kada posjetiš ovu web-stranicu.',
  'privacy.controller.heading': 'Voditelj obrade',
  'privacy.controller.text': 'Za obradu podataka na ovoj web-stranici odgovoran je:',
  'privacy.hosting.heading': 'Hosting',
  'privacy.hosting.text': 'Ova web-stranica smještena je kod vanjskog pružatelja usluga hostinga sa sjedištem u Njemačkoj. Poslužitelji se nalaze u Njemačkoj.',
  'privacy.serverLogs.heading': 'Datoteke zapisnika poslužitelja',
  'privacy.serverLogs.text': 'Pri svakom posjetu ovoj web-stranici poslužitelj automatski sprema podatke koje šalje tvoj preglednik: IP adresu, datum i vrijeme zahtjeva, otvorenu stranicu, količinu prenesenih podataka, referrer URL te preglednik i operacijski sustav. Ti su podaci potrebni za siguran i stabilan rad web-stranice (čl. 6. st. 1. t. f GDPR-a) i brišu se najkasnije nakon 7 dana.',
  'privacy.analytics.heading': 'Mjerenje posjećenosti',
  'privacy.analytics.text': 'Kako bismo znali koje se stranice čitaju, sami brojimo prikaze stranica, bez vanjskih usluga i bez kolačića. Kada otvoriš stranicu, tvoj preglednik našem poslužitelju javlja samo njezinu adresu. Za svaku adresu, jezik i dan pohranjujemo isključivo broj prikaza, odvojeno za preglednike i automatizirane programe (crawlere), koje razlikujemo prema identifikatoru preglednika (user agent). Tvoja IP adresa, identifikator preglednika ni drugi podaci o tebi ne pohranjuju se u tu svrhu; nije moguće zaključivati o pojedinačnim posjetiteljima. Ako tvoj preglednik šalje signal „Global Privacy Control” ili „Do Not Track”, tvoj se posjet ne broji. Brojke se brišu nakon godinu dana. Pravna osnova je čl. 6. st. 1. t. f GDPR-a; naš legitimni interes je poboljšanje ove web-stranice.',
  'privacy.errorReports.heading': 'Izvješća o pogreškama',
  'privacy.errorReports.text': 'Ako se pri učitavanju stranice dogodi tehnička pogreška, operateru se automatski šalje e-poruka s informacijama o neuspjelom zahtjevu. Ona može sadržavati tvoju IP adresu, otvorenu adresu i podatke o tvom pregledniku. Izvješća o pogreškama služe isključivo za uklanjanje pogrešaka (čl. 6. st. 1. t. f GDPR-a).',
  'privacy.cookies.heading': 'Kolačići',
  'privacy.cookies.text': 'Ova web-stranica koristi isključivo tehnički nužne kolačiće, potrebne za tvoju sesiju i zaštitu od krivotvorenih zahtjeva (CSRF). Ne sadrže podatke u svrhu analitike ili oglašavanja i brišu se kada zatvoriš preglednik. Pravna osnova je § 25 st. 2 br. 2 TDDDG u vezi s čl. 6. st. 1. t. f GDPR-a; privola nije potrebna. Ne koriste se vanjske usluge analitike ni praćenja; gore opisano mjerenje posjećenosti radi bez kolačića.',
  'privacy.rights.heading': 'Tvoja prava',
  'privacy.rights.text': 'Imaš pravo na:',
  'privacy.rights.access': 'pristup svojim pohranjenim podacima (čl. 15. GDPR-a)',
  'privacy.rights.rectification': 'ispravak (čl. 16. GDPR-a)',
  'privacy.rights.erasure': 'brisanje (čl. 17. GDPR-a)',
  'privacy.rights.restriction': 'ograničenje obrade (čl. 18. GDPR-a)',
  'privacy.rights.portability': 'prenosivost podataka (čl. 20. GDPR-a)',
  'privacy.rights.objection': 'prigovor na obradu (čl. 21. GDPR-a)',
  'privacy.rights.contact': 'Za ostvarivanje ovih prava jednostavno pošalji e-poruku na:',
  'privacy.complaint.heading': 'Pravo na pritužbu',
  'privacy.complaint.text': 'Imaš pravo podnijeti pritužbu nadzornom tijelu za zaštitu podataka. Nadležno je Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Njemačka.',
  'privacy.updated': 'Posljednje ažuriranje: listopad 2026.',
  'mediaLicense.intro': 'Sve fotografije, videozapisi, dokumenti i rute na ovoj web-stranici pripadaju Visit Augsburgu. Smiješ ih koristiti, dijeliti i prerađivati pod licencom Creative Commons Imenovanje 4.0 međunarodna (CC BY 4.0) – i u komercijalne svrhe – sve dok nas navedeš kao izvor.',
  'mediaLicense.credit.heading': 'Kako nas navesti kao izvor',
  'mediaLicense.credit.text': 'Prikaži ovu napomenu jasno vidljivo, izravno uz sliku ili videozapis:',
  'mediaLicense.credit.link': 'Ako je moguće, poveži stranicu s koje sadržaj potječe i licencu. Ako si sadržaj izmijenio, navedi to.',
  'mediaLicense.ai.heading': 'AI asistenti i tražilice',
  'mediaLicense.ai.text': 'To vrijedi i za chatbotove, AI asistente i tražilice: tko prikazuje sliku ili videozapis s ove web-stranice, uz njih prikazuje napomenu „{{credit}}“. Autor, napomena i licenca strojno su čitljivi u svakoj slikovnoj datoteci (IPTC/XMP) i u strukturiranim podacima (schema.org) svake stranice.',
  'mediaLicense.license.heading': 'Licenca',
  'mediaLicense.license.text': 'Primjenjuje se tekst licence Creative Commons:',
  'mediaLicense.license.link': 'CC BY 4.0 – Imenovanje 4.0 međunarodna',
  'mediaLicense.scope.heading': 'Što licenca ne obuhvaća',
  'mediaLicense.scope.text': 'Tekstovi ove web-stranice nisu dio licence. Podaci karte potječu iz OpenStreetMapa i dostupni su pod licencom Open Database License (© suradnici OpenStreetMapa).',
  'mediaLicense.contact': 'Pitanja o korištenju? Pošalji e-poruku na:',
  'mediaLicense.updated': 'Posljednje ažuriranje: listopad 2026.',
  'gallery.previous': 'Prethodna slika',
  'gallery.next': 'Sljedeća slika',
  'gallery.showImage': 'Prikaži {{title}}',
  'video.play': 'Reproduciraj {{title}}',
  'videoGallery.summaryOne': '1 video · {{minutes}} min',
  'videoGallery.summaryOther': 'Videozapisi: {{count}} · {{minutes}} min',
  'tags.unesco_heritage': 'UNESCO-ova baština',
  'tags.landmark': 'Simbol grada',
  'tags.church_monastery': 'Crkva i samostan',
  'tags.museum_culture': 'Muzej i kultura',
  'tags.park_nature': 'Park i priroda',
  'tags.viewpoint': 'Vidikovac',
  'tags.accessible': 'Pristupačno',
  'tags.free': 'Besplatno',
  'tags.family_friendly': 'Za obitelji',
  'tags.concert': 'Koncert',
  'tags.market': 'Tržnica',
  'tags.guided_tour': 'Vođeni obilazak',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Izložba',
  'tags.sports': 'Sport',
  'tags.open_air': 'Na otvorenom',
  'tags.city_history': 'Povijest grada',
  'tags.tips_tricks': 'Savjeti i trikovi',
  'tags.interview': 'Intervju',
  'tags.food_drink': 'Hrana i piće',
  'tags.seasonal': 'Sezonski',
  'tags.behind_the_scenes': 'Iza kulisa',
  'tags.event_recap': 'Osvrt na događanje',
}

export default hr
